// Named exports only: the context and the value box recipe are shared with
// InlineEdit through a direct import, never through the public barrel.
export { Property, PropertyList, PropertyValue } from './property-list';
export type { PropertyListProps, PropertyProps, PropertyValueProps } from './property-list';
